// extracted by mini-css-extract-plugin
export default {"divFullPage":"DivFullPage_divFullPage__UVPS7"};